import primary from "./primary";
import secondary from "./secondary";

export const PALETTES = {
  primary,
  secondary,
};

export default PALETTES;
